
export const tours = [
  {
    slug: 'oslob-whale-shark',
    title: '오슬롭 고래상어 투어',
    subtitle: '세부 최고의 버킷리스트 체험',
    badge: 'BEST',
    duration: '8시간',
    groupSize: '최대 10명',
    rating: 4.9,
    reviewCount: 487,
    price: 2500,
    originalPrice: 3200,
    heroImage: 'https://public.readdy.ai/ai/img_res/7e99c755d5f764f6e23b7994e75ff8cf.jpg',
    gallery: [
      'https://readdy.ai/api/search-image?query=tourist%20snorkeling%20alongside%20massive%20whale%20shark%20underwater%20oslob%20cebu%20philippines%20clear%20blue%20tropical%20ocean%20water%20amazing%20marine%20encounter%20adventure%20experience%20simple%20clean%20background&width=600&height=400&seq=oslob-g1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=beautiful%20tumalog%20waterfall%20cascading%20down%20mossy%20rocks%20into%20turquoise%20pool%20oslob%20cebu%20philippines%20lush%20tropical%20jungle%20vegetation%20misty%20atmosphere%20simple%20clean%20background&width=600&height=400&seq=oslob-g2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=traditional%20filipino%20bangka%20outrigger%20boat%20on%20calm%20turquoise%20ocean%20water%20oslob%20cebu%20philippines%20early%20morning%20sunrise%20golden%20light%20fishing%20village%20simple%20clean%20background&width=600&height=400&seq=oslob-g3&orientation=landscape',
      'https://readdy.ai/api/search-image?query=group%20of%20happy%20asian%20tourists%20wearing%20life%20jackets%20on%20boat%20ready%20for%20whale%20shark%20watching%20oslob%20cebu%20philippines%20excited%20faces%20ocean%20adventure%20simple%20clean%20background&width=600&height=400&seq=oslob-g4&orientation=landscape'
    ],
    description: '세부에서 가장 인기 있는 투어! 세계에서 가장 큰 물고기인 고래상어와 함께 수영하는 잊을 수 없는 경험을 선사합니다. 오슬롭의 맑은 바다에서 고래상어를 가까이에서 만나고, 투말록 폭포에서 시원한 물놀이까지 즐기는 완벽한 하루 코스입니다.',
    highlights: [
      { icon: 'ri-time-line', label: '소요 시간', value: '약 8시간' },
      { icon: 'ri-group-line', label: '그룹 규모', value: '최대 10명' },
      { icon: 'ri-star-line', label: '만족도', value: '98%' },
      { icon: 'ri-shield-check-line', label: '안전 보장', value: '전문 가이드' }
    ],
    itinerary: [
      { time: '03:30', title: '호텔 픽업', desc: '세부 시티 호텔에서 편안한 차량으로 픽업합니다. 차 안에서 간단한 아침 식사가 제공됩니다.' },
      { time: '06:00', title: '오슬롭 도착 & 브리핑', desc: '오슬롭 고래상어 센터에 도착하여 안전 교육과 스노클링 장비를 착용합니다.' },
      { time: '06:30', title: '고래상어 스노클링', desc: '방카 보트를 타고 바다로 나가 고래상어와 함께 수영합니다. 약 30분간 진행됩니다.' },
      { time: '08:00', title: '투말록 폭포', desc: '아름다운 투말록 폭포에서 수영과 사진 촬영을 즐깁니다.' },
      { time: '10:00', title: '점심 식사', desc: '현지 레스토랑에서 필리핀 전통 점심 식사를 즐깁니다.' },
      { time: '11:30', title: '호텔 복귀', desc: '편안하게 호텔로 돌아갑니다.' }
    ],
    includes: ['호텔 왕복 픽업', '전문 한국어 가이드', '스노클링 장비', '점심 식사', '입장료 포함', '생수 및 간식', '수중 사진 촬영'],
    excludes: ['개인 경비', '팁 (선택)', 'GoPro 대여 (₱500 추가)'],
    reviews: [
      { name: '김민지', role: '직장인', rating: 5, text: '고래상어를 바로 눈앞에서 보다니! 평생 잊지 못할 경험이었어요. 가이드님이 정말 친절하셨습니다.', date: '2025.01.15' },
      { name: '박준호', role: '사업가', rating: 5, text: '새벽에 출발하는 게 힘들었지만 고래상어를 보는 순간 피로가 싹 사라졌어요. 투말록 폭포도 너무 예뻤습니다.', date: '2025.01.08' },
      { name: '이수진', role: '대학생', rating: 5, text: '친구들과 함께 갔는데 모두 감동받았어요. 사진도 예쁘게 찍어주시고 최고의 투어였습니다!', date: '2024.12.22' }
    ]
  },
  {
    slug: 'kawasan-falls',
    title: '카와산 폭포 투어',
    subtitle: '에메랄드빛 폭포에서의 짜릿한 모험',
    badge: 'HOT',
    duration: '6시간',
    groupSize: '최대 8명',
    rating: 4.8,
    reviewCount: 352,
    price: 2200,
    originalPrice: 2800,
    heroImage: 'https://readdy.ai/api/search-image?query=stunning%20kawasan%20waterfall%20with%20multiple%20tiers%20cascading%20into%20bright%20turquoise%20emerald%20green%20pool%20surrounded%20by%20lush%20tropical%20jungle%20vegetation%20cebu%20philippines%20paradise%20swimming%20spot%20misty%20atmosphere%20simple%20clean%20background&width=1200&height=700&seq=kawasan-hero&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=adventurous%20tourists%20canyoneering%20jumping%20into%20clear%20blue%20water%20pool%20kawasan%20cebu%20philippines%20extreme%20sport%20cliff%20jumping%20tropical%20canyon%20adventure%20simple%20clean%20background&width=600&height=400&seq=kawasan-g1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=bamboo%20raft%20floating%20under%20kawasan%20waterfall%20turquoise%20water%20tropical%20jungle%20cebu%20philippines%20relaxing%20experience%20mist%20spray%20simple%20clean%20background&width=600&height=400&seq=kawasan-g2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=narrow%20tropical%20canyon%20with%20crystal%20clear%20turquoise%20water%20flowing%20between%20tall%20rock%20walls%20cebu%20philippines%20canyoneering%20adventure%20lush%20green%20vegetation%20simple%20clean%20background&width=600&height=400&seq=kawasan-g3&orientation=landscape',
      'https://readdy.ai/api/search-image?query=happy%20tourists%20swimming%20in%20emerald%20green%20natural%20pool%20at%20base%20of%20waterfall%20kawasan%20cebu%20philippines%20tropical%20paradise%20refreshing%20swim%20simple%20clean%20background&width=600&height=400&seq=kawasan-g4&orientation=landscape'
    ],
    description: '세부에서 가장 아름다운 폭포인 카와산 폭포에서 캐녀닝 어드벤처를 즐겨보세요! 에메랄드빛 물속으로 다이빙하고, 자연 속 협곡을 탐험하며, 대자연의 경이로움을 온몸으로 느낄 수 있는 최고의 액티비티 투어입니다.',
    highlights: [
      { icon: 'ri-time-line', label: '소요 시간', value: '약 6시간' },
      { icon: 'ri-group-line', label: '그룹 규모', value: '최대 8명' },
      { icon: 'ri-star-line', label: '만족도', value: '96%' },
      { icon: 'ri-fire-line', label: '난이도', value: '중급' }
    ],
    itinerary: [
      { time: '05:00', title: '호텔 픽업', desc: '세부 시티에서 출발하여 카와산 폭포로 이동합니다.' },
      { time: '07:30', title: '캐녀닝 시작', desc: '안전 장비를 착용하고 전문 가이드와 함께 캐녀닝을 시작합니다.' },
      { time: '08:00', title: '협곡 탐험', desc: '자연 협곡을 따라 수영, 점프, 클라이밍을 즐깁니다.' },
      { time: '10:00', title: '카와산 폭포 도착', desc: '메인 폭포에서 수영과 대나무 뗏목 체험을 합니다.' },
      { time: '11:00', title: '점심 식사', desc: '폭포 근처 레스토랑에서 맛있는 점심을 즐깁니다.' },
      { time: '11:30', title: '호텔 복귀', desc: '편안하게 호텔로 돌아갑니다.' }
    ],
    includes: ['호텔 왕복 픽업', '전문 캐녀닝 가이드', '안전 장비 (헬멧, 구명조끼)', '점심 식사', '입장료 포함', '방수 가방'],
    excludes: ['개인 경비', '팁 (선택)', 'GoPro 대여 (₱500 추가)'],
    reviews: [
      { name: '최영수', role: '프리랜서', rating: 5, text: '캐녀닝이 이렇게 재미있을 줄 몰랐어요! 절벽에서 뛰어내리는 건 정말 짜릿했습니다.', date: '2025.01.20' },
      { name: '정하늘', role: '대학생', rating: 5, text: '폭포가 정말 장관이었어요. 에메랄드빛 물이 너무 예뻐서 계속 수영하고 싶었습니다.', date: '2025.01.12' },
      { name: '강서연', role: '회사원', rating: 4, text: '체력이 좀 필요하지만 그만큼 보람 있는 투어였어요. 사진도 정말 잘 나옵니다!', date: '2024.12.30' }
    ]
  },
  {
    slug: 'nalusuan-island',
    title: '나루수안 아일랜드',
    subtitle: '에메랄드빛 바다 위의 작은 천국',
    badge: '',
    duration: '7시간',
    groupSize: '최대 12명',
    rating: 4.7,
    reviewCount: 298,
    price: 1800,
    originalPrice: 2300,
    heroImage: 'https://readdy.ai/api/search-image?query=pristine%20white%20sand%20beach%20with%20crystal%20clear%20shallow%20turquoise%20water%20nalusuan%20island%20marine%20sanctuary%20cebu%20philippines%20long%20wooden%20boardwalk%20pier%20extending%20into%20ocean%20tropical%20paradise%20palm%20trees%20simple%20clean%20background&width=1200&height=700&seq=nalusuan-hero&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=colorful%20tropical%20fish%20swimming%20around%20coral%20reef%20underwater%20nalusuan%20island%20marine%20sanctuary%20cebu%20philippines%20snorkeling%20paradise%20clear%20blue%20water%20simple%20clean%20background&width=600&height=400&seq=nalusuan-g1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=long%20wooden%20pier%20boardwalk%20extending%20over%20shallow%20turquoise%20water%20nalusuan%20island%20cebu%20philippines%20tropical%20paradise%20sunny%20day%20palm%20trees%20simple%20clean%20background&width=600&height=400&seq=nalusuan-g2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=tourists%20relaxing%20on%20white%20sand%20beach%20with%20palm%20trees%20nalusuan%20island%20cebu%20philippines%20tropical%20getaway%20crystal%20clear%20water%20simple%20clean%20background&width=600&height=400&seq=nalusuan-g3&orientation=landscape',
      'https://readdy.ai/api/search-image?query=fresh%20grilled%20seafood%20lunch%20spread%20on%20table%20by%20the%20beach%20cebu%20philippines%20delicious%20filipino%20cuisine%20tropical%20dining%20experience%20simple%20clean%20background&width=600&height=400&seq=nalusuan-g4&orientation=landscape'
    ],
    description: '나루수안 섬은 세부에서 가장 아름다운 해양보호구역 중 하나입니다. 맑은 바다에서 다양한 열대어와 산호초를 감상하며 스노클링을 즐기고, 하얀 모래사장에서 여유로운 시간을 보내세요. 가족 여행에 특히 추천하는 힐링 투어입니다.',
    highlights: [
      { icon: 'ri-time-line', label: '소요 시간', value: '약 7시간' },
      { icon: 'ri-group-line', label: '그룹 규모', value: '최대 12명' },
      { icon: 'ri-star-line', label: '만족도', value: '95%' },
      { icon: 'ri-heart-line', label: '추천 대상', value: '가족 여행' }
    ],
    itinerary: [
      { time: '07:00', title: '호텔 픽업', desc: '세부 시티 호텔에서 막탄 선착장으로 이동합니다.' },
      { time: '08:30', title: '방카 보트 출발', desc: '전통 방카 보트를 타고 나루수안 섬으로 출발합니다.' },
      { time: '09:30', title: '스노클링 체험', desc: '해양보호구역에서 열대어와 산호초를 감상합니다.' },
      { time: '11:00', title: '섬 자유시간', desc: '하얀 모래사장에서 휴식하며 사진 촬영을 즐깁니다.' },
      { time: '12:00', title: '해산물 점심', desc: '신선한 해산물 바비큐 점심을 즐깁니다.' },
      { time: '14:00', title: '호텔 복귀', desc: '보트를 타고 돌아와 호텔로 이동합니다.' }
    ],
    includes: ['호텔 왕복 픽업', '한국어 가이드', '방카 보트', '스노클링 장비', '해산물 점심', '입장료 포함', '생수'],
    excludes: ['개인 경비', '팁 (선택)', '추가 음료'],
    reviews: [
      { name: '한지민', role: '주부', rating: 5, text: '아이들과 함께 갔는데 정말 좋았어요! 물이 얕아서 아이들도 안전하게 스노클링할 수 있었습니다.', date: '2025.02.01' },
      { name: '윤성호', role: '직장인', rating: 4, text: '힐링 그 자체였습니다. 바다가 너무 맑아서 물고기가 다 보여요. 점심도 맛있었습니다.', date: '2025.01.18' },
      { name: '송미래', role: '프리랜서', rating: 5, text: '인스타 사진 찍기 최고의 장소! 나무 다리에서 찍은 사진이 정말 예쁘게 나왔어요.', date: '2025.01.05' }
    ]
  },
  {
    slug: 'bohol-day-tour',
    title: '보홀 당일 투어',
    subtitle: '초콜릿 힐과 안경원숭이의 섬',
    badge: 'BEST',
    duration: '12시간',
    groupSize: '최대 10명',
    rating: 4.9,
    reviewCount: 421,
    price: 3200,
    originalPrice: 4000,
    heroImage: 'https://readdy.ai/api/search-image?query=panoramic%20view%20of%20iconic%20chocolate%20hills%20bohol%20philippines%20hundreds%20of%20perfectly%20cone%20shaped%20brown%20hills%20stretching%20to%20horizon%20under%20bright%20blue%20sky%20with%20white%20clouds%20lush%20green%20vegetation%20foreground%20simple%20clean%20background&width=1200&height=700&seq=bohol-hero&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=adorable%20tiny%20philippine%20tarsier%20with%20huge%20round%20eyes%20clinging%20to%20tree%20branch%20bohol%20philippines%20worlds%20smallest%20primate%20cute%20wildlife%20close%20up%20portrait%20simple%20clean%20background&width=600&height=400&seq=bohol-g1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=loboc%20river%20cruise%20with%20floating%20restaurant%20boat%20surrounded%20by%20lush%20tropical%20palm%20trees%20bohol%20philippines%20scenic%20river%20tour%20buffet%20lunch%20simple%20clean%20background&width=600&height=400&seq=bohol-g2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=baclayon%20church%20oldest%20stone%20church%20in%20philippines%20bohol%20historic%20colonial%20spanish%20architecture%20heritage%20site%20simple%20clean%20background&width=600&height=400&seq=bohol-g3&orientation=landscape',
      'https://readdy.ai/api/search-image?query=man%20made%20forest%20tall%20mahogany%20trees%20creating%20beautiful%20canopy%20tunnel%20road%20bohol%20philippines%20scenic%20drive%20lush%20green%20vegetation%20simple%20clean%20background&width=600&height=400&seq=bohol-g4&orientation=landscape'
    ],
    description: '세부에서 페리로 2시간, 보홀 섬의 모든 명소를 하루에 둘러보는 알찬 투어입니다. 세계적으로 유명한 초콜릿 힐의 장관, 세계에서 가장 작은 영장류 안경원숭이, 로복 강 크루즈까지! 보홀의 매력을 한 번에 느낄 수 있습니다.',
    highlights: [
      { icon: 'ri-time-line', label: '소요 시간', value: '약 12시간' },
      { icon: 'ri-group-line', label: '그룹 규모', value: '최대 10명' },
      { icon: 'ri-star-line', label: '만족도', value: '98%' },
      { icon: 'ri-compass-line', label: '명소', value: '5곳 이상' }
    ],
    itinerary: [
      { time: '05:00', title: '세부 항구 출발', desc: '세부 항구에서 고속 페리를 타고 보홀로 이동합니다.' },
      { time: '07:00', title: '보홀 도착', desc: '보홀 탁빌라란 항구에 도착하여 투어를 시작합니다.' },
      { time: '08:00', title: '안경원숭이 보호센터', desc: '세계에서 가장 작은 영장류 안경원숭이를 만납니다.' },
      { time: '09:30', title: '초콜릿 힐 전망대', desc: '1,268개의 원뿔형 언덕이 펼쳐진 장관을 감상합니다.' },
      { time: '11:00', title: '로복 강 크루즈', desc: '뷔페 점심과 함께 아름다운 강을 유람합니다.' },
      { time: '13:00', title: '인공 숲 & 바클라욘 성당', desc: '마호가니 인공 숲과 역사적인 성당을 방문합니다.' },
      { time: '15:00', title: '세부 복귀', desc: '페리를 타고 세부로 돌아옵니다.' }
    ],
    includes: ['호텔 왕복 픽업', '왕복 페리 티켓', '한국어 가이드', '로복 강 뷔페 점심', '모든 입장료', '에어컨 차량'],
    excludes: ['개인 경비', '팁 (선택)', '추가 간식'],
    reviews: [
      { name: '최영수', role: '사업가', rating: 5, text: '보홀 투어가 정말 환상적이었습니다. 초콜릿 힐의 장관과 귀여운 안경원숭이까지! 세심한 배려에 감동했어요.', date: '2025.01.25' },
      { name: '김태희', role: '주부', rating: 5, text: '로복 강 크루즈가 정말 좋았어요. 뷔페 음식도 맛있고 강 풍경이 너무 아름다웠습니다.', date: '2025.01.10' },
      { name: '이동현', role: '직장인', rating: 5, text: '하루 만에 보홀의 모든 명소를 볼 수 있어서 효율적이었어요. 가이드님 설명도 재미있었습니다.', date: '2024.12.28' }
    ]
  },
  {
    slug: 'moalboal-snorkeling',
    title: '모알보알 스노클링',
    subtitle: '정어리 떼와 바다거북이의 바다',
    badge: '',
    duration: '9시간',
    groupSize: '최대 8명',
    rating: 4.8,
    reviewCount: 276,
    price: 2800,
    originalPrice: 3500,
    heroImage: 'https://readdy.ai/api/search-image?query=massive%20swirling%20school%20of%20millions%20of%20sardines%20forming%20spectacular%20ball%20shape%20underwater%20moalboal%20cebu%20philippines%20snorkeling%20diver%20watching%20incredible%20marine%20phenomenon%20clear%20blue%20ocean%20water%20simple%20clean%20background&width=1200&height=700&seq=moalboal-hero&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=large%20green%20sea%20turtle%20swimming%20gracefully%20over%20coral%20reef%20underwater%20moalboal%20cebu%20philippines%20marine%20wildlife%20encounter%20clear%20blue%20tropical%20water%20simple%20clean%20background&width=600&height=400&seq=moalboal-g1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=snorkeler%20swimming%20through%20massive%20school%20of%20sardines%20underwater%20moalboal%20cebu%20philippines%20incredible%20marine%20experience%20millions%20of%20silver%20fish%20simple%20clean%20background&width=600&height=400&seq=moalboal-g2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=beautiful%20white%20sand%20beach%20panagsama%20moalboal%20cebu%20philippines%20palm%20trees%20crystal%20clear%20water%20tropical%20paradise%20coastline%20simple%20clean%20background&width=600&height=400&seq=moalboal-g3&orientation=landscape',
      'https://readdy.ai/api/search-image?query=colorful%20vibrant%20coral%20reef%20with%20tropical%20fish%20underwater%20moalboal%20cebu%20philippines%20diverse%20marine%20ecosystem%20snorkeling%20paradise%20simple%20clean%20background&width=600&height=400&seq=moalboal-g4&orientation=landscape'
    ],
    description: '모알보알은 세부 남서부에 위치한 스노클링의 성지입니다. 수백만 마리의 정어리 떼가 만드는 장관과 바다거북이를 가까이에서 만날 수 있는 특별한 경험! 해변에서 바로 입수하여 놀라운 해양 생태계를 탐험하세요.',
    highlights: [
      { icon: 'ri-time-line', label: '소요 시간', value: '약 9시간' },
      { icon: 'ri-group-line', label: '그룹 규모', value: '최대 8명' },
      { icon: 'ri-star-line', label: '만족도', value: '97%' },
      { icon: 'ri-fish-line', label: '해양 생물', value: '거북이+정어리' }
    ],
    itinerary: [
      { time: '06:00', title: '호텔 픽업', desc: '세부 시티에서 모알보알로 이동합니다 (약 2.5시간).' },
      { time: '08:30', title: '정어리 스노클링', desc: '파낭사마 비치에서 수백만 마리 정어리 떼와 함께 수영합니다.' },
      { time: '10:00', title: '바다거북이 만남', desc: '거북이 서식지에서 바다거북이를 가까이에서 관찰합니다.' },
      { time: '11:30', title: '점심 식사', desc: '해변 레스토랑에서 신선한 해산물 점심을 즐깁니다.' },
      { time: '12:30', title: '산호초 스노클링', desc: '다양한 산호초와 열대어를 감상합니다.' },
      { time: '15:00', title: '호텔 복귀', desc: '세부 시티로 돌아갑니다.' }
    ],
    includes: ['호텔 왕복 픽업', '전문 가이드', '스노클링 장비', '해산물 점심', '입장료', '생수 및 간식'],
    excludes: ['개인 경비', '팁 (선택)', 'GoPro 대여 (₱500 추가)'],
    reviews: [
      { name: '오지현', role: '여행 블로거', rating: 5, text: '정어리 떼 속에서 수영하는 건 정말 초현실적인 경험이었어요! 거북이도 너무 귀여웠습니다.', date: '2025.02.05' },
      { name: '장민수', role: '직장인', rating: 5, text: '스노클링 좋아하시는 분들은 무조건 가세요. 세부에서 최고의 스노클링 포인트입니다.', date: '2025.01.22' },
      { name: '배수아', role: '대학생', rating: 4, text: '이동 시간이 좀 길지만 그만한 가치가 있어요. 바다가 정말 맑고 아름다웠습니다.', date: '2025.01.08' }
    ]
  },
  {
    slug: 'sunset-cruise',
    title: '선셋 크루즈',
    subtitle: '로맨틱한 세부의 황금빛 석양',
    badge: '',
    duration: '4시간',
    groupSize: '최대 15명',
    rating: 4.8,
    reviewCount: 189,
    price: 2600,
    originalPrice: 3200,
    heroImage: 'https://readdy.ai/api/search-image?query=breathtaking%20golden%20orange%20sunset%20over%20calm%20ocean%20water%20with%20silhouette%20of%20luxury%20cruise%20boat%20cebu%20philippines%20romantic%20evening%20sky%20dramatic%20clouds%20reflection%20on%20water%20surface%20simple%20clean%20background&width=1200&height=700&seq=sunset-hero&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=elegant%20dinner%20table%20setup%20on%20cruise%20boat%20deck%20with%20candles%20and%20flowers%20sunset%20ocean%20view%20cebu%20philippines%20romantic%20dining%20experience%20simple%20clean%20background&width=600&height=400&seq=sunset-g1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=couple%20enjoying%20champagne%20toast%20on%20boat%20deck%20watching%20golden%20sunset%20over%20ocean%20cebu%20philippines%20romantic%20cruise%20experience%20simple%20clean%20background&width=600&height=400&seq=sunset-g2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=live%20acoustic%20guitar%20musician%20performing%20on%20cruise%20boat%20deck%20evening%20sunset%20cebu%20philippines%20entertainment%20music%20simple%20clean%20background&width=600&height=400&seq=sunset-g3&orientation=landscape',
      'https://readdy.ai/api/search-image?query=panoramic%20view%20of%20cebu%20city%20skyline%20from%20ocean%20at%20golden%20hour%20sunset%20warm%20orange%20light%20reflecting%20on%20calm%20water%20simple%20clean%20background&width=600&height=400&seq=sunset-g4&orientation=landscape'
    ],
    description: '세부의 아름다운 석양을 바다 위에서 감상하는 프리미엄 크루즈 투어입니다. 라이브 음악과 함께 맛있는 저녁 식사를 즐기며, 황금빛으로 물드는 세부의 하늘을 배경으로 잊을 수 없는 추억을 만들어보세요. 커플, 신혼여행에 특히 추천합니다.',
    highlights: [
      { icon: 'ri-time-line', label: '소요 시간', value: '약 4시간' },
      { icon: 'ri-group-line', label: '그룹 규모', value: '최대 15명' },
      { icon: 'ri-star-line', label: '만족도', value: '97%' },
      { icon: 'ri-music-line', label: '특별 서비스', value: '라이브 음악' }
    ],
    itinerary: [
      { time: '15:30', title: '호텔 픽업', desc: '세부 시티 호텔에서 막탄 선착장으로 이동합니다.' },
      { time: '16:30', title: '크루즈 승선', desc: '웰컴 드링크와 함께 크루즈에 승선합니다.' },
      { time: '17:00', title: '출항 & 라이브 음악', desc: '라이브 기타 연주를 들으며 바다를 유람합니다.' },
      { time: '17:30', title: '선셋 감상', desc: '황금빛 석양을 배경으로 사진 촬영을 즐깁니다.' },
      { time: '18:00', title: '저녁 식사', desc: '코스 요리 저녁 식사를 즐깁니다.' },
      { time: '19:30', title: '호텔 복귀', desc: '선착장에서 호텔로 이동합니다.' }
    ],
    includes: ['호텔 왕복 픽업', '웰컴 드링크', '코스 저녁 식사', '라이브 음악', '선셋 크루즈', '사진 촬영 서비스'],
    excludes: ['개인 경비', '팁 (선택)', '추가 주류'],
    reviews: [
      { name: '강서연', role: '신혼부부', rating: 5, text: '신혼여행으로 완벽했어요! 석양이 너무 아름다웠고 음식도 맛있었습니다. 라이브 음악이 분위기를 더해줬어요.', date: '2025.02.10' },
      { name: '임재현', role: '직장인', rating: 5, text: '여자친구 생일에 예약했는데 정말 감동적이었습니다. 로맨틱한 분위기 최고!', date: '2025.01.28' },
      { name: '노은지', role: '프리랜서', rating: 4, text: '석양 사진이 정말 예쁘게 나왔어요. 음식도 맛있고 전체적으로 만족스러운 투어였습니다.', date: '2025.01.15' }
    ]
  }
];
